import * as React from "react";
import Layout from "../../components/Layout";
import ContactCards from "./ContactCards";
import ContactForm from "./ContactForm";
import DefaultHeader from "../../components/DefaultHeader";
import {useTranslation} from "react-i18next";

const ContactView = () => {
	const {t} = useTranslation();

	return (
		<Layout title={t('Contact us')}>
			<DefaultHeader
				backgroundClass="contact-bg"
				breadcrumbs={[
					{
						title: t('Contact us'),
						path: '/contact-us',
					}
				]}
				title={t('Contact us')}
			/>
			<ContactCards/>
			<ContactForm/>
		</Layout>
	);
};

export default ContactView;
